import React, { useState } from 'react';
import PageHeader from '../components/PageHeader'
import Preloader from '../components/Preloader'
import Footer from '../components/Footer';
import { FaSearch } from 'react-icons/fa';
import ScrollReveal from '../components/ScrollReveal';
import { Helmet } from 'react-helmet';


const tours = [
    {
        title: 'East Legon 360 Aerial Virtual Tour',
        category: 'Ghana',
        description: 'Explore the vibrant East Legon neighborhood in Accra, Ghana, with this immersive 360-degree aerial tour showcasing its bustling streets, modern architecture, and lush greenery.',
        image: '/assets/eastlegon360arielview.mp4',
        link: 'http://84.247.162.31:4000/index.html',
    },
    {
        title: 'BridgeView Resort and LakeSide Virtual Tour',
        category: 'Ghana',
        description: 'Discover the tranquil beauty of BridgeView Resort and LakeSide with this virtual tour, showcasing its picturesque landscapes, comfortable accommodations, and recreational facilities.',
        image: '/assets/bridgeviewresortandlakeside.avif',
        link: 'http://84.247.162.31:4003/',
    },
    {
        title: 'Bel Air Crest Hotel Virtual Tour',
        category: 'Ghana',
        description: 'Experience luxury living at Bel Air Crest hotel through this virtual tour, highlighting its stunning architecture, elegant interiors, and breathtaking views in a serene environment',
        image: '/assets/belaircrest.avif',
        link: 'https://tour.panoee.net/iframe/BelAirCrest',
    },
];

const VirtualTour = () => {
    const [filter, setFilter] = useState('All');
    const [searchTerm, setSearchTerm] = useState('');

    const filteredTours = tours.filter(tour => {
        const matchesCategory = filter === 'All' || tour.category === filter;
        const matchesSearch = tour.title.toLowerCase().includes(searchTerm.toLowerCase()) || tour.description.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    return (
        <div className='font-nixie-one bg-gray-50 min-h-screen text-gray-800'>
            <Helmet>
                <title>Virtual Tours | VRIFY Africa</title>
                <meta name="description" content="Explore our interactive virtual tours. Experience locations in Ghana from the comfort of your screen." />
            </Helmet>
            <PageHeader />
            <Preloader />
            <main>
                {/* Hero Section */}
                <section className="relative h-[50vh] bg-cover bg-center" style={{ backgroundImage: "url('/assets/roundworld1.jpg')" }}>
                    <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                        <div className="text-center text-white px-4">
                            <h1 className="text-5xl md:text-6xl font-cormorant-upright font-bold">Virtual Tours</h1>
                            <p className="mt-4 text-sm md:text-sm max-w-3xl mx-auto">Explore the africa from your screen. Our immersive virtual tours bring Africa's most iconic destinations to you.</p>
                        </div>
                    </div>
                </section>
                {/* Tours Section */}
                <section className="py-20 px-4">
                    <div className="container mx-auto">
                        <div className="flex flex-col md:flex-row justify-between items-center mb-12">
                            <div className="flex space-x-2 md:space-x-4 mb-6 md:mb-0">
                                {['All', 'Ghana', 'West Africa', 'Africa'].map(cat => (
                                    <button key={cat} onClick={() => setFilter(cat)} className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-300 ${filter === cat ? 'bg-green-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}>
                                        {cat}
                                    </button>
                                ))}
                            </div>
                            <div className="relative w-full md:w-96">
                                <input type="text" placeholder="Search virtual tours..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="w-96 pl-10 pr-4 py-1 text-sm border rounded-full focus:outline-none focus:ring-1 focus:ring-green-500" />
                                <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                            </div>
                        </div>
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                                {filteredTours.map((tour, index) => (
                                    <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden flex flex-col group">
                                        <div className="relative h-40">
                                            {/\.(mp4|webm|ogg)$/i.test(tour.image) ? (
                                                <video src={tour.image} loop autoPlay muted playsInline className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" />
                                            ) : (
                                                <img src={tour.image} alt={tour.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" />
                                            )}
                                            <span className="absolute top-2 right-2 bg-green-600 text-white text-xs font-semibold px-2 py-1 rounded">{tour.category}</span>
                                        </div>
                                        <div className="p-4 flex flex-col flex-grow">
                                            <h3 className="text-xl font-bold font-cormorant-upright mb-2">{tour.title}</h3>
                                            <p className="text-gray-600 text-sm font-semibold flex-grow">{tour.description}</p>
                                            <a href={tour.link} target='_blank' rel="noreferrer" className="inline-block capitalize mt-4 self-start px-5 py-2 text-sm bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition-colors duration-300">
                                                view virtual tour
                                            </a>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </ScrollReveal>
                        {filteredTours.length === 0 && (
                            <p className="text-center text-gray-500 mt-8">Sorry, No tours found matching your search.</p>
                        )}
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    )
}

export default VirtualTour